import { REQUIRED_DOCUMENTS } from "../DocumentsF/documentRequirements";
import { FiAlertCircle } from "react-icons/fi";

const MissingDocumentsModal = ({ missingDocs, onGoToDocs, onDismiss }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
      
      {/* Card */}
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden">

        {/* Header (Announcement style) */}
        <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-200 bg-gray-50">
          <FiAlertCircle className="text-blue-600 w-5 h-5" />
          <h2 className="text-sm font-semibold text-gray-800">
            System Announcement
          </h2>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">

          <p className="text-gray-700 text-sm leading-relaxed">
            Your application is currently incomplete. To continue processing,
            please upload the required documents listed below.
          </p>

          {/* Documents List */}
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Missing Documents
            </p>

            <ul className="space-y-2">
              {missingDocs.map((key) => (
                <li
                  key={key}
                  className="flex items-center gap-3 text-sm text-gray-700"
                >
                  <span className="w-2 h-2 bg-blue-600 rounded-full flex-shrink-0" />
                  {REQUIRED_DOCUMENTS[key]}
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Footer Actions */}
        <div className="flex flex-col sm:flex-row gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onGoToDocs}
            className="
              flex-1 bg-blue-600 text-white py-2.5 rounded-lg
              text-sm font-medium hover:bg-blue-700 transition
            "
          >
            Upload Documents
          </button>

          <button
            onClick={onDismiss}
            className="
              flex-1 border border-gray-300 text-gray-700 py-2.5 rounded-lg
              text-sm hover:bg-gray-100 transition
            "
          >
            Dismiss
          </button>
        </div>

      </div>
    </div>
  );
};

export default MissingDocumentsModal;
